import {Box, ColorPaletteProp, useTheme} from "@mui/joy";
import {SxProps} from "@mui/joy/styles/types";
import React from "react";

type IconBoxProps = {
    style?: SxProps,
    color: ColorPaletteProp,
    children: React.ReactNode,
}
const IconBoxComponent = (props: IconBoxProps) => {
    const theme = useTheme()
    return <Box component={"div"} sx={{
        backgroundColor: theme.palette[props.color].softBg,
        color: theme.palette[props.color].softColor,
        borderRadius: 10,
        padding: 1.5,
        width: "max-content",
        height: "max-content",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...props.style,
    }}>
        {props.children}
    </Box>
}

export default IconBoxComponent